import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import ProgramManagementPage from "@/pages/service/ProgramManagementPage";

export const Route = createFileRoute("/service/program-management")({
  head: () => pageHead("Program Management Services", "AI-assisted project planning, Agile methodologies, and expert program management for successful delivery.", "/service/program-management", false),
  component: ProgramManagementPage,
});
